import { Directive, EventEmitter, Input, Output } from '@angular/core';
@Directive()
export class NotesPageBase {
    @Output() onOpenTableReferenceDialog = new EventEmitter<void>();
    @Output() onAddNumberToggleEmit = new EventEmitter<{ checked: boolean; tableIndex?: number }>();

    @Input() addNumbering: boolean; // used for components that only have 1 table
    @Input() addReferencing: boolean;
    @Input() hasFootnotes: boolean;
    @Input() referenceFlis: string[];

    openReferenceDialog(): void {
        this.onOpenTableReferenceDialog.emit();
    }

    onAddNumberToggleChange(checked: boolean, tableIndex?: number): void {
        if (checked == null) {
            checked = !this.addNumbering;
        }

        this.onAddNumberToggleEmit.emit({
            checked: checked,
            tableIndex: tableIndex,
        });
    }
}
